import { FILE_LOADING_STATE } from "redux/constants/MyM"

export const changeFileLoadingState = (data) => {
    return {
      type: FILE_LOADING_STATE,
      payload: data
    }
  }